module.exports = __webpack_public_path__ + "0fa8c32e3e0a74e4368abf750e2c69ec.svg";